import * as React from "react";

import { PortalToPaymentPageAboveSection } from "../portals";

import {
  ReactCheckout2022Route,
  useReactCheckout2022Router,
} from "../providers";

export const HeaderPortal: React.FunctionComponent = (props) => {
  const { currentRoute } = useReactCheckout2022Router();
  if (currentRoute === ReactCheckout2022Route.payment) {
    return (
      <PortalToPaymentPageAboveSection>
        {props.children || []}
      </PortalToPaymentPageAboveSection>
    );
  }
  return <React.Fragment>{props.children || []}</React.Fragment>;
};
